import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createIntegrationRequest } from "./integrationRequestAPI";

export const createIntegrationRequestAction = createAsyncThunk(
  "integrationRequest/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createIntegrationRequest(payload);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Something went wrong");
    }
  },
);

const integrationRequestSlice = createSlice({
  name: "integrationRequest",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    clearIntegrationRequestState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createIntegrationRequestAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(createIntegrationRequestAction.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createIntegrationRequestAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearIntegrationRequestState } =
  integrationRequestSlice.actions;

export default integrationRequestSlice.reducer;